import React from 'react';
import { Container, Spinner, Message } from './LoadingSpinner.styled';

export interface LoadingSpinnerProps {
  /** ローディングメッセージ */
  message?: string;
  /** フルページ表示（min-height: 100vh） */
  fullPage?: boolean;
  /** スピナーサイズ */
  size?: 'small' | 'medium' | 'large';
}

/**
 * ローディングスピナーコンポーネント
 * アプリ全体で統一されたローディング表示を提供
 */
export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = '読み込み中...',
  fullPage = false,
  size = 'medium',
}) => {
  return (
    <Container $fullPage={fullPage}>
      <Spinner $size={size} />
      {message && <Message>{message}</Message>}
    </Container>
  );
};

export default LoadingSpinner;
